<label class="form-label">
  <span>{{ 'meeting.members' | translate }}</span>
</label>

@if (form.value.members.length === 0) {
  <div class="mb-2">{{ 'meeting.members.empty' | translate }}</div>
}

<ul>
  @for (entry of formControls; track entry; let index = $index) {
    <li [formGroup]="entry">
      <span class="update-meeting__member-name">
        <span>{{ userMap[entry.value.userId] | contactName }}</span>
        <span class="font-xs ms-1 text-muted">{{ userMap[entry.value.userId].loginName }}</span>
      </span>
      @if (entry.value.role !== MemberRole.OWNER) {
        <ng-select
          class="update-meeting__member-role"
          [clearable]="false"
          [items]="memberRoles"
          (change)="somethingChanged()"
          bindLabel="label"
          bindValue="value"
          formControlName="role"
        >
          <ng-template let-item="item" ng-label-tmp ng-option-tmp>
            {{ 'meeting.memberRole.' + item.label | translate }}
          </ng-template>
        </ng-select>
      } @else {
        <div class="update-meeting__member-role">
          <span class="badge text-bg-info">{{ 'meeting.memberRole.' + entry.value.role | translate }}</span>
        </div>
      }
      <span class="update-meeting__member-action">
        @if (entry.value.role !== MemberRole.OWNER) {
          <portal-icon-button
            [disabled]="entry.value.role === MemberRole.OWNER"
            [portalTippy]="'meeting.members.remove' | translate"
            (onClick)="remove(index)"
            iconClass="far fa-minus-circle"
          ></portal-icon-button>
        }
      </span>
    </li>
  }

  <!-- New member -->
  <li class="update-meeting__new-member" [formGroup]="form">
    <ng-select
      id="userId"
      [clearable]="false"
      [items]="users"
      [placeholder]="
        (users.length === 0 ? 'meeting.members.noMoreAvailable' : 'meeting.members.add') | translate
      "
      bindLabel="label"
      bindValue="value"
      formControlName="userId"
      portalInputValidityState
    >
      <ng-template let-item="item" ng-option-tmp>
        <div class="d-flex flex-column">
          <span>{{ userMap[item.value] | contactName }}</span>
          <span class="text-muted font-xs">{{ userMap[item.value].loginName }}</span>
        </div>
      </ng-template>
    </ng-select>
  </li>
</ul>
